import React from "react";
import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./HeroSection.css";
import Lines from "./../../Images/lines.png";
import ByeBye from "./../../Images/bye-bye.png";
import transLines from "./../../Images/texture.png";
// import phoneStill from './../../Images/phone.png'
// import phoneStill from './../../Images/phone2.png'
// import phoneStill from './../../Images/phone3.png'
import phone from "./../../Images/phone.png";
import phone1 from "./../../Images/phone2.png";
import phone2 from "./../../Images/phone3.png";
import nfcCard from "./../../Images/nfc-card.png";
import Logo from "./../../Images/businessbayWhite.png";
import { useNavigate } from "react-router-dom";
import WhatsappIcon from "./../../Images/whatsapp.png";
import Newaddlines from "./../../Images/newaddlines.png";
import EnquirePopup from "../EnquirePopup";

const fronturl = process.env.REACT_APP_FRONTEND_URL

const HeroSection = () => {
  const navigate = useNavigate(null);
  const [currentImage, setCurrentImage] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const images = [phone, phone1, phone2]; // Replace with your image file names

  // useEffect(() => {
  //   const initialDelay = setTimeout(() => {
  //     const intervalId = setInterval(() => {
  //       setCurrentImage((prevImage) => (prevImage + 1) % images.length);
  //     }, 2000);
  
  //     return () => clearInterval(intervalId);
  //   }, 1000);
  
  //   return () => clearTimeout(initialDelay);
  // }, [images.length]);

  const handleButtonClick = () => {
    // Meta Pixel event tracking for CTA click
    if (window.fbq) {
      window.fbq('track', 'Lead');  // 'Lead' is an example event, you can change it to any custom event name
    }
    // Add any additional functionality you want on button click here
  };

  const handlePopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };
  

  useEffect(() => {
    const initialDelay = setTimeout(() => {
      const intervalId = setInterval(() => {
        setCurrentImage((prevImage) => (prevImage + 1) % images.length);
      }, 2000);
  
      return () => clearInterval(intervalId);
    }, 1000);
  
    return () => clearTimeout(initialDelay);
  }, [images.length]);

  return (
    <>
      <Container fluid className="heromain">
        <div className="top-lines">
          {" "}
          <img src={Lines} />{" "}
        </div>
        {/* <div className="trans-lines">
          {" "}
          <img src={transLines} />{" "}
        </div> */}
        

        <Container className="hero-content">
          <div className="row align-center">
            <div className="header">
              <img
                // style={{ cursor: "pointer", width:"156px" }}
                className="logotop"
                onClick={() => navigate("/")}
                // onClick={() => window.location.href = `${fronturl}`}
                // onClick={() => window.open(`${fronturl}`, '_blank')}
                src={Logo}
               
              />
              <a style={{ cursor: "pointer" }} 
                onClick={handlePopup}
              className="green-button green-button-top ">
                {/* <img src={WhatsappIcon} style={{width:"32px", height:"32px"}}/> */}
                Get yours today
            </a>
            </div>
          </div>
          <div className="row align-center col-reverse">
            <div className="col-md-6">
              <div style={{display:"flex"}} className="byebyemain">
                <img src={ByeBye}/>
                <h1>Paper Cards...</h1>
              </div>
              <h2 className="godigital">Upgrade to NFC Business Cards</h2>
              {/* <h1>Say Yes to Smart NFC Business Cards</h1> */}
              <h3>
                {/* Experience a 15-day FREE Trial that helps you connect with
                people easily and build important relationships. */}
                Effortlessly manage your business profile, book appointments, showcase your online store on web and mobile, and track Google reviews--all in one place
              </h3>
              {/* <div className="hero-buttons">
                <div
                  style={{ cursor: "pointer" }}
                  // onClick={() => navigate("/register")}
                  // onClick={() => window.location.href = `${fronturl}register`}
                  onClick={() => window.open(`${fronturl}register`, '_blank')}
                  className="red-button"
                >
                  Start Free Trial
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  // onClick={() => navigate("/faqs")}
                  // onClick={() => window.location.href = `${fronturl}faqs`}
                  onClick={() => window.open(`${fronturl}faqs`, '_blank')}
                  className="dark-button"
                >
                  How it Works
                </div>
              </div> */}
            </div>
            <div className="col-md-6 phones" style={{minHeight:"340px"}}>
            <div className="nfc-card">
              {" "}
              <img src={nfcCard} />
          </div>
              <img className="phone-still" src={images[currentImage]} />
              {/* <img className='phone-still' src={phoneStill}/> */}
            </div>
          </div>


          <Container fluid>
            {/* <img src={Newaddlines} className="newaddliness"/> */}
            <div className="newaddlines">
              {/* <h2>Why stick with paper when you can go green and digital? NFC is the future of smart networking!</h2> */}
              <h4><span>Limited Time Offer: </span> Get your NFC Business Card for only INR 499/year!</h4>
              <a style={{ cursor: "pointer"}} 
                onClick={handlePopup}
              className="green-button">
                {/* <img src={WhatsappIcon} style={{width:"36px", height:"36px"}}/> */}
                Get started now
            </a>
            </div>
          </Container>

          <div className="stats-main">
            <ul>
              <li>
                <h2 className="stats">30+</h2>
                <h5 className="stats-text">Countries Worldwide Shipping</h5>
              </li>
              <li>
                <h2 className="stats">50k</h2>
                <h5 className="stats-text">App Users</h5>
              </li>
              <li>
                <h2 className="stats">40k</h2>
                <h5 className="stats-text">Card Users</h5>
              </li>
              <li>
                <h2 className="stats">45k</h2>
                <h5 className="stats-text">Business Users</h5>
              </li>
            </ul>
          </div>
          {showPopup && (
       <EnquirePopup  open={showPopup} onClose={closePopup} setOpen={setShowPopup}/>
      )}
        </Container>
      </Container>
    </>
  );
};

export default HeroSection;
